import React from "react";
import styles from "./TaskCountBoxes.module.css";

/** Keys returned by the backend as `status_counts` / `my_status_counts`. */
export type TaskStatusCounts = Partial<
  Record<"total" | "pending" | "processing" | "paused" | "completed" | "canceled", number>
>;

// Same palette as the dashboard Priority / Status pills.
const BOXES = [
  { key: "total", label: "All Tasks", filter: "All Status", bg: "#f2f4f8", fg: "#27324e" },
  { key: "pending", label: "Pending", filter: "Pending", bg: "#fff5e1", fg: "#d48b18" },
  { key: "processing", label: "Processing", filter: "Processing", bg: "#e6f0ff", fg: "#2077cf" },
  { key: "paused", label: "Paused", filter: "Paused", bg: "#f3e8ff", fg: "#7c3aed" },
  { key: "completed", label: "Completed", filter: "Completed", bg: "#e3fce8", fg: "#1e8542" },
] as const;

interface Props {
  counts?: TaskStatusCounts | null;
  /** Status filter label currently applied (highlights that box). */
  active?: string;
  /** Called with the status filter label ("All Status", "Pending", ...). */
  onSelect?: (filter: string) => void;
}

const TaskCountBoxes: React.FC<Props> = ({ counts, active, onSelect }) => (
  <div className={styles.row}>
    {BOXES.map((b) => (
      <button
        key={b.key}
        type="button"
        className={`${styles.box} ${active === b.filter ? styles.active : ""}`}
        style={{ background: b.bg, color: b.fg, cursor: onSelect ? "pointer" : "default" }}
        onClick={onSelect ? () => onSelect(b.filter) : undefined}
        tabIndex={onSelect ? 0 : -1}
      >
        <span className={styles.value}>{String(counts?.[b.key] ?? 0).padStart(2, "0")}</span>
        <span className={styles.label}>{b.label}</span>
      </button>
    ))}
  </div>
);

export default TaskCountBoxes;
